<ng-template #connectionLost>
  <div>
    <mat-icon style="margin-right: 5px">wifi_off</mat-icon>
    <div class="message">Network connection lost</div>
  </div>
</ng-template>
